module.exports = __webpack_public_path__ + "img/Empress.6685bc21.jpg";